'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import UITextArea from '../input/UITextArea';
import UITextInput from '../input/UITextInput';
export const defaultRenderers = {
  text: props => /*#__PURE__*/_jsx(UITextInput, Object.assign({}, props)),
  textarea: props => /*#__PURE__*/_jsx(UITextArea, Object.assign({}, props))
};